<template>
  <div class="onlineGoods">
    <el-dialog
    :title="$t('other.a2387')"
    :visible.sync="excelDia"
    width="30%"
   >
    <div>
      <el-upload
        class="upload-demo"
        drag
        action=""
        :on-change="handleChange"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :limit="limitUpload"
        :auto-upload="false"
        accept=".xlsx,.xls"
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">{{$t('other.a2388')}}<em>{{$t('other.a368')}}</em></div>
        <div class="el-upload__tip" slot="tip">{{$t('other.a2389')}}</div>
      </el-upload>
      <br/>
      <div v-if="vedifne"><i class="el-icon-loading"></i>{{$t('other.a2390')}}</div>
      <div v-if="bolTextDESC" style="color:red">{{textDESC}}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="excelDia = false">{{$t('other.a106')}}</el-button>
      <el-button type="primary" @click="importExml()">{{$t('other.a2391')}}</el-button>
    </span>
  </el-dialog>
    <!-- 成功或失败绑定的提示 -->
    <el-dialog :title="$t('mygoods').details.title" :visible.sync="storetable" center width="80%">
			<div class="quit-wapper">
				<span class="quit-wrapper-item">
			    <i  class="iconfont icon-gouSolid-copy vbfk"></i>
          {{succesList.length}}{{$t('other.a2504')}}{{$t('mygoods').details.success}}</span>
				<span class="quit-wrapper-item">
           <i  class="iconfont icon-jinggao1 vbfkh"></i>
          {{errorList.length}}{{$t('other.a2504')}}{{$t('other.a2505')}}</span>
			</div>
			<div class="quit-box" >
				<el-table style="margin-left: 10px;" :data="succesList"  height="460px" border>
					<el-table-column property="name" :label="$t('mygoods').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="scope.row.image" style="width: 150px;height: 150px" />
								<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="skuName" :label="$t('mygoods').details.SKU" width="150" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('mygoods').details.cusCode"  :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
				<el-table style="margin-left: 10px;" :data="errorList" height="460px" border>
					<el-table-column property="name" :label="$t('mygoods').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="scope.row.image" style="width: 150px;height: 150px" />
								<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column  :label="$t('other.a688')" >
            <template scope="scope" >
              <span>{{scope.row.msg}}</span>
            </template>
					</el-table-column>
				</el-table>
			</div>
			<div class="ttp-uu">
				<el-button @click="submitBBox()" type="primary">{{$t('other.a279')}}</el-button>
			</div>
			
		</el-dialog>
    <!-- 商品清单 -->
		<el-dialog :title="$t('mygoods').qingdang.title" :visible.sync="caigouTable"  width="70%">
			<div >
				<el-table :data="targetList " height="450" border>
					<el-table-column  label="Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" label="" trigger="hover">
								<img  :src="scope.row.image" style="width: 150px;height: 150px" />
								<img   slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
          <el-table-column  :label="$t('other.a2506')"  :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.itemSku" ></el-input>
						</template>
					</el-table-column>
          <el-table-column  :label="$t('other.a736')"  :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.variationSku" ></el-input>
						</template>
					</el-table-column>
          <el-table-column  label="skuName" width="280" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.variationName"></el-input>
						</template>
					</el-table-column>
          <el-table-column label="Cost" >
						<template scope="scope">
               <el-input-number v-model="scope.row.cost"   size="mini"></el-input-number>
						</template>
					</el-table-column>
          <el-table-column :label="$t('other.a2507')" >
						<template scope="scope">
              <el-switch
              v-model="scope.row.sensitive"
              :active-text="$t('other.a191')"
              :inactive-text="$t('other.a192')">
            </el-switch>
            </template>
					</el-table-column>
					<el-table-column :label="$t('mygoods').qingdang.operate" >
						<template scope="scope">
							<el-button type="text" size="mini" @click="deleteItem(scope.$index)"  style="width: 60px;">{{$t('mygoods').qingdang.dele}}</el-button>
						</template>
					</el-table-column>
				</el-table>
					<div class="footer">
						<el-button  @click="addStoreItem()" type="primary">{{$t('mygoods').qingdang.submit}}</el-button>
					</div>
			</div>
		</el-dialog>
    <div class="header_top">
      <div style="font-size:22px;font-weight:bold;margin-bottom:10px">
          {{$t('other.a2508')}}
      </div>
      <!-- 一级菜单栏 -->
      <div class="query_list">
        <condition :ConditionOption="ConditionOption" @getOrderParams="getOrderParams" ></condition>
       
      </div>
       <div class="querylisttwo">
         <div style="display:flex">
           <el-input style="width:300px;margin-right:5px" size="medium" v-model="search" clearable  :placeholder="$t('other.a2396')"></el-input>
           <el-button size="medium" @click="searchCode()" type="primary">{{$t('other.a2205')}}</el-button>
           <el-button type="primary" @click="excelDia=true">{{$t('other.a2509')}}</el-button>
           <el-button type="primary" @click="exportXml()">{{$t('other.a2510')}}</el-button>
           <el-button type="primary" @click="syncProduct()">{{$t('other.a2394')}}</el-button>
         </div>
         <div class="cirle">
            <span class="kvmi">{{targetList.length}}</span>
            <el-button size="medium" type="primary" @click="caigouTable=true">{{$t('other.a2511')}}</el-button>
          </div>
        </div>
    </div>
    <!-- 产品展示列表 -->
    <div class="goodsArea">
        <div class="item_list_wrpper" v-for="(item,index) in newUserstoreItem" :key="index">
            <div class="headerDesc">
                <div class="title">
                  <span class="kmvn">{{$t('other.a838')}}：{{conversion(item.shopId)}}</span>
                  <span class="kmvn">
                   <span>{{$t('other.a735')}}:</span>
                    <span v-show="!item.checked03">{{item.itemSku}}</span>
                    <div v-show="item.checked03"><el-input size="mini" v-model="item.itemSku" placeholder=""></el-input></div>
                    <span v-show="item.checked03" class="ciuk" @click="updataSku(item)">{{$t('other.a274')}}</span>
                    <span v-show="!item.checked03" class="ciuk" @click="item.checked03=true"><i class="el-icon-edit-outline"></i></span>
                  </span>
                  <span class="kmvn">{{$t('other.a68')}}:{{item.itemId}}</span>
                </div>
                <div>
                    <el-button style="width:120px" size="mini" :type="item.checked01 ? 'danger' : 'primary'" @click="getAll(item,index)">{{item.checked01 ? $t('other.a706') : $t('other.a378')}}</el-button>
                </div>
            </div>
            <div class="item_list">
                <div class="imgBox">
                <img style="width:100%" :src="item.image ? item.image : item.variations[0].image" alt="">
                </div>
                <div class="itemDesc">
                    <div>{{item.itemName}}</div>
                </div>
                <div style="flex:1">
                    <div class="variation" v-for="(children,index02) in item.variationsCopy" :key="index02">
                            <a  :title="children.variationSku"><span class="children">sku:{{children.variationSku ? children.variationSku : children.variationName}}</span></a>
                            <span class="children children2" v-show="children.specName">{{$t('other.a1357')}}：{{children.specName}}</span>
                            <span class="children children3">{{$t('other.a226')}}{{children.cusCode}}</span>
                            <span class="children">{{$t('other.a831')}}:{{children.price}}</span>
                            <span class="children">
                                <el-button style="width:120px" v-if="children.cusCode" disabled size="mini" type="info"  >{{$t('other.a2512')}}</el-button>
                                <el-button style="width:120px" v-if="!children.cusCode"  size="mini" :type="children.checked ? 'danger' : 'primary'"  @click="target(item,children,index02)">{{children.checked ? $t('other.a2513') : $t('other.a2514')}}</el-button>
                            </span>
                    </div>
                    <div class="moreData" v-show="item.variationsCopy.length !== item.variations.length && item.variations.length > 4" @click="viewMore(item,index)">{{$t('other.a1335')}} sku ({{$t('other.a964')}}{{item.variations.length}}{{$t('other.a1337')}})</div>
                    <div class="hideData" v-show="item.variationsCopy.length == item.variations.length && item.variations.length > 4" @click="hideMore(item,index)">{{$t('other.a1336')}}</div>
                </div>
            </div>
        </div>

        <!-- 分页器 -->
        <div class="Pager">
          <el-pagination
            @size-change="handleSizeChangeTwo"
            @current-change="handleCurrentChangeTwo"
            :current-page="currentPage"
            :page-sizes="[15, 20, 50, 100]"
            :page-size="50"
            layout="total, sizes, prev, pager, next, jumper"
            :total="itemsCount"
          >
          </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>

import userStoreItems from "../../api/moudles/userStoreItems";
import QrcodeDialog from '../../components/dialog/qrcodeDialog'
import Condition from '../../components/condition'
import utils from '../../utils/utils'
import { mapState, mapActions, mapMutations } from "vuex";
import mygoods from '../../api/moudles/mygoods';
import readExcel from '../../utils/readxls.js'
import XLSX from 'xlsx'

export default {
  data() {
    return {
      ConditionOption:[{
          id:1,
          desc:this.$t("allorders.Platform"),
          isActive:0,
          list:[{
            label:this.$t('other.a358'),
            value:-1,
            active:false
          },{
            label:'SHOPEE',
            value:0,
            active:false
          },{
            label:'LAZADA',
            value:1,
            active:false
          },{
            label:'TIKTOK',
            value:2,
            active:false
          },{
            label:'TEMU',
            value:3,
            active:false
          }]
        },],
      openDialog: false,
      bolTextDESC:false,
      textDESC:null,
      warehouseId: null,
      search:null,
      warehouseOption: null,
      TitleDesc: "",
      handleParam: null,
      limitUpload: 1,  // 上传excell时，同时允许上传的最大数
      fileTemp: [],
      succesList:[],
      targetShopId:null,
      errorList:[],
      excelDia:false,
      cusCode: "",
      newUserstoreItem: [],
      vedifne:false,
      offset: 15,
      instockdia:false,
      storetable:false,
      getDataList: {},
      caigouTable:false,
      page: 0,
      checkedAll: false,
      isExtened: false,
      maincusCode:0,
      component:null,
      storeId:null,
      isEdit: -1,
      dialogTableVisibleTwo: false,
      additionParents: [],
      originData:[],
      isShow: false,
      isEditGoods: false,
      shopInfo:{},
      multipleSelection: [],
      additionItem: null,
      listErrorOptions: [],
      targetList:[],
      itemsCount:0,
      tableList: [],
      tableCount: 0,
      currentPage4: 1,
      currentPage:1,
      page: 0,
      componentValue:1,
      value: null,
       options2: [
        {
          label: this.$t('other.a251'),
          value: 1,
        },
        {
          label: this.$t('other.a1339'),
          value: 2,
        },
        {
          label: this.$t('other.a497'),
          value: 3,
        },
      ],
      options: [
        {
          label: this.$t('other.a1340'),
          value: null,
        },
        {
          label: this.$t('other.a1341'),
          value: true,
        },
        {
          label: this.$t('other.a1342'),
          value: false,
        },
      ],
    };
  },
  components:{
    Condition
  },
  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      userName: (state) => state.shopaccess.userInfo.userName,
      isChooseList: (state) => state.userStoreItems.isChooseList
    }),
    
  },
  watch: {
      cusCode(){
          if(!this.cusCode){
              this.getDataList.cusCode=null
              this.getData()
          }
      },
      search(){
        if(!this.search){
          this.getDataList.itemName=null
          this.getData()
        }
      },
      excelDia(){
        if(!this.excelDia){
          this.handleRemove()
        }
      },
      originData(){
        if(this.originData){
          setTimeout(() => {
            let ttp=false
            this.originData.forEach(p => {
              for(let i in p){
                if(p[i] == undefined){
                  ttp=true
                }
              }
            })
            // if(ttp){
            //   this.textDESC='excel表格数据错误，表格内容要严格与导出产品表格头部信息一致'
            // }else{
            //   this.textDESC='数据校验成功，请继续操作！'
            // }
            this.textDESC=this.$t('other.a2398')+ this.originData.length +this.$t('other.a2399')
            
            this.bolTextDESC=true
            this.vedifne=false
          },1000)
        }
      },
      warehouseId(){
          localStorage.removeItem('godownentry')
          this.targetList=[]
      },
      targetList(){
        if(!this.targetList.length){
          this.newUserstoreItem.forEach(p => {
            p.checked01=false
            p.variations.forEach(i => {
              i.checked=false
              i.checked02=false
            })
          })
        }
      },


    
  },
  beforeDestroy(){
      localStorage.removeItem('godownentry')
  },

  created() {
    let arr1=utils.getAllshop()
    this.component=this.$route.query.component == 'true' ? true :false
    this.storeId=Number(this.$route.query.storeId)

    this.shopInfo.all=[...utils.onlyGetShopeeshop(),...utils.onlyGetLAZADAshop(),...utils.onlyGetTikTokshop(),...utils.onlyGetTEMUshop()]
    this.shopInfo.SHOPEE=utils.onlyGetShopeeshop()
    this.shopInfo.LAZADA=utils.onlyGetLAZADAshop()
    this.shopInfo.TIKTOK=utils.onlyGetTikTokshop()
    this.shopInfo.TEMU=utils.onlyGetTEMUshop()
    let arr2=arr1.map((p,index) => {
        return {
          label:p.label,
          value:p.value,
          active:false
        }
    })
    if(arr1){
      this.ConditionOption.push( {
						id:1,
						desc:this.$t('other.a2166'),
						isActive:0,
						list:arr2.slice(1)
					},{
						id:2,
						desc:this.$t('other.a360'),
						isActive:0,
						list:[{
              label:this.$t('other.a1636'),
							value:true,
							active:false
            },{
              label:this.$t('other.a2400'),
							value:false,
							active:false
            },]
					},)
    }
    console.log('shopInfo',this.shopInfo)
    this.init()

  },
  methods: {
    ...mapActions("userStoreItems", [
      "updateGroup",
      "sellerUpdateStoreItemDetail",
      'getInstockoperaterecore',
      'deleStoreItems'
    ]),
    ...mapMutations('userStoreItems', [
        'SET_ITEMS_COUNT',
    ]),

    ...mapActions('mygoods', [
			'tongBuShopee',
			]),

    updataSku(item){
      console.log(item)
      mygoods
      .updateItemSku({
        itemKey:item.variations[0].itemKey,
        shopId:item.shopId,
        sku:item.itemSku,
        userId:this.userId,
      })
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',JSON.parse(res.data))
      let ttp=JSON.parse(res.data)
      console.log('ttp',ttp)
      item.checked03=false
      this.$message.success(this.$t('other.a665'))
      
      }else{
      this.$message.warning(res.msg)
      item.checked03=false
      }
      })
      console.log(item)
    },  

    searchCode(){
      this.getDataList.itemName=this.search.trim()
      this.getData()
      console.log(this.getDataList)
    },

    importExml(){
      console.log(this.originData)
      if(!this.originData){
        this.$message.warning(this.$t('other.a2401'))
        return
      }

      let list=this.originData.map(p => {
        return {
          addition:false,
          component:this.component,
          cost:p.cost,
          image:p.image ,
          itemKey:p.itemKey,
          packageHeight:p.packageHeight,
          packageLength:p.packageLength,
          packageWidth:p.packageWidth,
          userId:this.userId,
          storeId:this.storeId,
          skuName:p.variationSku,
          variationName:p.variationName,
          itemSku:p.itemSku,
        }
      })


      mygoods
      .addGoodsInStore(list)
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      
      this.succesList=res.data.successItem
      this.errorList=res.data.errorItem
      this.excelDia=false
      this.storetable=true
      }else{
      this.$message.warning(res.msg)
      }
      })

      console.log(list)

       
    },

    syncProduct(){
      
      console.log(this.targetShopId)
      let tip=this.$t('other.a2402')+ utils.showshopNameByshopIdOne(this.targetShopId) +this.$t('other.a2403')
      let text=this.$t('other.a2404')
      this.$confirm(text, tip, {
      confirmButtonText: this.$t('other.a755'),
      cancelButtonText: this.$t('other.a146'),
      type: 'warning'
      }).then(() => {
         this.tongBuShopee({
          shopId:this.targetShopId,
          userId:this.userId
        }).then(res => {
          if(res.code === 200){
            this.showLoading()
            sessionStorage.setItem('targetShopId',this.targetShopId);
            setTimeout(() => {
              this.hideLoading()
              this.$message.success(this.$t('other.a2405'))
            },10000)
          }else{
            this.$message.warning(res.msg)
          }
        })
      })
     
    },

    exportXml(){
      let params=JSON.parse(JSON.stringify(this.getDataList))
      params.offset=this.itemsCount+1
      userStoreItems
      .getOnlineGoods(params)
      .then((res) => {
        if(res.code === 200){
          console.log(res.data)
          let arr=[]
          res.data.items.forEach(p => {
            p.variations.forEach(i => {
              arr.push({
                image:i.image,
                itemName:p.itemName,
                shopId:p.shopId,
                itemSku:p.itemSku,
                itemId:p.itemId,
                cusCode:i.cusCode,
                variationSku:i.variationSku,
                variationName:i.variationName,
                price:i.price,
                itemKey:i.itemKey,
                packageHeight:i.packageHeight,
                packageLength:i.packageLength,
                packageWidth:i.packageWidth,
                weight:i.weight,
                cost:0
              })
            })
            
          })
          let list=['image','itemName','shopId','itemSku','itemId','cusCode','variationSku','variationName','price','itemKey','packageHeight','packageLength','packageWidth','weight','cost']
          console.log('arr',arr)
          utils.exPortEXml(arr,list,list)
        }else{
          this.$message.warning(this.$t('other.a2406'))
        }
      })
    },

    deleteItem(index){
      console.log(index)
      this.targetList.splice(index,1)
    },

    addStoreItem(){
      if(!this.targetList.length){
        this.$message.warning(this.$t('other.a2407'))
        return
      }
      let flag=false
      this.targetList.forEach(p => {
        if(!p.itemSku){
          flag=true
        }
      })
      if(flag){
         this.$message.warning(this.$t('other.a2515'))
         return
      }

      let groupId=this.$route.query.groupId

      let list=this.targetList.map(p => {
        return {
          addition:false,
          component:this.component,
          cost:p.cost,
          groupId:groupId ? groupId : null,
          image:p.image ? p.image : p.mainImage,
          imageId:p.imageId,
          itemKey:p.itemKey,
          packageHeight:p.packageHeight,
          packageLength:p.packageLength,
          packageWidth:p.packageWidth,
          sensitive:p.sensitive,
          weight:p.weight,
          userId:this.userId,
          storeId:this.storeId,
          skuName:p.variationSku ? p.variationSku : p.variationName,
          variationName:p.variationName,
          itemSku:p.itemSku,

        }
      })

      mygoods
      .addGoodsInStore(list)
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      
      this.succesList=res.data.successItem
      this.errorList=res.data.errorItem
      this.caigouTable=false
      this.storetable=true
      }else{
      this.$message.warning(res.msg)
      }
      })

      console.log('list',list)
    }, 

    submitBBox(){
      this.storetable=false
      this.targetList=[]
      if(this.component){
        this.$router.push({
          path:'/stockProduct/single'
        })

      }else{
        this.$router.push({
          path:'/stockProduct/combo'
        })
      }
    },


    init(){
      this.getDataList.categoryIds=null
      this.getDataList.itemName=null
      this.getDataList.normal=true
      this.getDataList.offset=50
      this.getDataList.page=0
      
      this.getDataList.shopIds=[this.ConditionOption[1].list[0].value]
      this.getDataList.status='NORMAL'
      this.getDataList.userId=this.userId
      this.targetShopId=this.ConditionOption[1].list[0].value
      this.getData()

    },

    
    getOrderParams(data){
        console.log('data',data)
        console.log('shopInfo',this.shopInfo)
        let index=data[0].list[data[0].isActive].label

        console.log(index);
        if(data[0].isActive == 0){
          this.ConditionOption[1].list=this.shopInfo['all']
        }else {
          this.ConditionOption[1].list=this.shopInfo[index]
        }
        
        let index01=data[1].list[data[1].isActive].value
        let index02=data[2].list[data[2].isActive].value

        this.targetShopId=index01
        console.log(index01)
        console.log("===1====")
        this.getDataList.shopIds=[index01]
        this.getDataList.normal=index02
        console.log('getDataList',this.getDataList)
        this.getData()
		},

    getAll(item,index){
        console.log(item,index)
        item.checked01=!item.checked01
        if(item.checked01){//全选
            item.variations.forEach(p => {
                if(!p.checked && !p.cusCode){
                    this.targetList.push(p)
                }
                p.checked=true
            })
        }else{//反选
            item.variations.forEach(p => {
              if(!p.checked){
                
              }else{
               
                let index=this.targetList.findIndex(item => item.variationId == p.variationId)
                if(index>-1){
                  this.targetList.splice(index,1)
                }
                p.checked=false

              }
            })
        }
        localStorage.setItem('godownentry',JSON.stringify(this.targetList))
        console.log('targetList',this.targetList)
    },

    hideMore(item,index){
        item.variationsCopy=item.variations.slice(0,4)
    },

    viewMore(item,index){
        console.log(item,index)
        item.variationsCopy=item.variations
    },

    target(outitem,item,index){
        item.checked=!item.checked
        if(item.checked){
            this.targetList.push(item)
        }else{
            let index=this.targetList.findIndex(item => item.cusCode == item.cusCode)
            this.targetList.splice(index,1)
        }
        localStorage.setItem('godownentry',JSON.stringify(this.targetList))

        console.log('targetList',this.targetList)
    },

   

    conversion(id){
      return utils.showshopNameByshopIdOne(id)
    },

    getData(){
      userStoreItems
      .getOnlineGoods(this.getDataList)
      .then((res) => {
        if (res.code === 200) {
          console.log(res.data)
          let list=JSON.parse(localStorage.getItem('godownentry'))
          console.log(list)
          this.itemsCount=res.data.count
           this.newUserstoreItem=[]
          if(!res.data.items){
            this.newUserstoreItem=[]
            return
          }
          res.data.items.forEach((p) => {
           p.checked01=false
            p.checked02 = false;
            p.checked03=false
            
            p.variations.forEach((k) => {
                k.checked=false
                k.cost=0

                 if(list){
                    k.checked = list.find(item => item.itemKey === k.itemKey)
                }else{
                    k.checked=false
                }

                if(!k.checked){
                     p.checked01 = false;
                }else{
                    p.checked01 = true;
                }


            });


            p.variationsCopy=p.variations.slice(0,4)
            this.newUserstoreItem.push(p);
          });

          console.log('list',this.newUserstoreItem)
        }
      });
    },

    //控制每页显示订单条数
    handleSizeChangeTwo(val) {
      this.getDataList.offset = parseInt(`${val}`);
      this.handleCurrentChangeTwo();
    },
    //显示当前第几页
    handleCurrentChangeTwo(val) {
     
      this.getDataList.page = `${val}` == "undefined" ? 0 : (parseInt(`${val}`) - 1) * this.getDataList.offset;
      this.getData();
    },

    importfxx(obj) {
            let _this = this;
            let inputDOM = this.$refs.inputer;
            // 通过DOM取文件数据
            this.file = event.currentTarget.files[0];
            var rABS = false; //是否将文件读取为二进制字符串
            var f = this.file;
            var reader = new FileReader();
            //if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function(f) {
                var binary = "";
                var rABS = false; //是否将文件读取为二进制字符串
                var pt = this;
                var wb; //读取完成的数据
                var outdata;
                var reader = new FileReader();
                reader.onload = function(e) {
                    var bytes = new Uint8Array(reader.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    //此处引入，用于解析excel
                    var XLSX = require("xlsx");
                    if (rABS) {
                        wb = XLSX.read(btoa(fixdata(binary)), {
                        //手动转化
                        type: "base64"
                        });
                    } else {
                        wb = XLSX.read(binary, {
                        type: "binary"
                        });
                    }
                    outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); 
                    //outdata就是读取的数据（不包含标题行即表头，表头会作为对象的下标）
                    //此处可对数据进行处理
                    let arr = [];
                    outdata.map(v => {
                        let obj = {}
                        obj.image = v['image']
                        obj.itemName = v['itemName']
                        obj.shopId = v['shopId']
                        obj.itemSku = v['itemSku']
                        obj.itemId = v['itemId']
                        obj.cusCode = v['cusCode']
                        obj.variationSku = v['variationSku']
                        obj.variationName = v['variationName']
                        obj.price = v['price']
                        obj.itemKey = v['itemKey']
                        obj.packageHeight = v['packageHeight']
                        obj.packageLength = v['packageLength']
                        obj.packageWidth = v['packageWidth']
                        obj.weight = v['weight']
                        obj.cost = v['cost']
                        arr.push(obj)
                    });
                    _this.da=arr;
                    _this.dalen=arr.length;
                    console.log('arr',arr)
                    _this.vedifne=true
                    _this.originData=arr;
                };
                reader.readAsArrayBuffer(f);
            };
            if (rABS) {
                reader.readAsArrayBuffer(f);
            } else {
                reader.readAsBinaryString(f);
            }
        },



      // 文件超出个数限制时的钩子
      exceedFile(files, fileList) {
        this.$message.warning(this.$t('other.a2408')+` ${this.limitNum} `+this.$t('other.a2409')+` ${files.length + fileList.length} `+this.$t('other.a1337'));
      },
      //上传文件时处理方法  
        handleChange(file, fileList){
            this.fileTemp = file.raw;
            console.log(this.fileTemp)
            if(this.fileTemp){
                if((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') 
                    || (this.fileTemp.type == 'application/vnd.ms-excel')){
                    this.importfxx(this.fileTemp);
                    
                } else {
                    this.$message({
                        type:'warning',
                        message:this.$t('other.a2410')
                    })
                }
            } else {
                this.$message({
                    type:'warning',
                    message:this.$t('other.a2411')
                })
            }
        },
        //超出最大上传文件数量时的处理方法
        handleExceed(){
            this.$message({
                type:'warning',
                message:this.$t('other.a2412')
            })
            return;
        },
        //移除文件的操作方法
        handleRemove(file,fileList){
            this.fileTemp = null
            this.vedifne=false
            this.bolTextDESC=false
        }

      
  },
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.onlineGoods {
  background-color: #eee;

  .ttp-uu{
    text-align: right;
    margin-top: 20px;
  }

  .quit-box{
      display: flex;
    }

  .quit-wapper{
    display: flex;

    .quit-wrapper-item{
      width: 50%;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: rgb(0, 199, 163);
    }

    .quit-wrapper-item:nth-child(2){
      width: 50%;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: rgb(255, 82, 69);
    }

    .vbfkh{
      color: rgb(255, 82, 69);
      font-size: 20px;
      margin-right: 15px;
    }

    .vbfk{
      color: rgb(0, 199, 163);
      font-size: 20px;
      margin-right: 15px;
    }

  }
  // @include main-right-content();

  .footer{
    text-align: right;
    padding-top: 10px;
  }


  .cirle{
    position: relative;

    .kvmi{
      display: block;
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #fff;
      background-color: red;
      border-radius: 50%;
      position: absolute;
      top: -15px;
      left: -15px;


    }
  }

  .Pager{
    position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	
  }

  .el-icon-loading{
    font-size: 18px;
    margin-right:15px;
  }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }

  .header_top {
    background-color: #fff;
  

    .query-list-tcp {
      padding: 10px 0 20px 0;
    }
    .query_list {
    
      padding: 0px 0 5px 0;
      @include flex-between();
    }
    .querylisttwo{
      display: flex;
      justify-content: space-between;
    }

    .create {
		position: relative;
		margin-left: 30px;
	}

    .cirlle {
		position: absolute;
		top: -15px;
		left: -13px;
		display: block;
		width: 30px;
		height: 30px;
		background-color: red;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
		color: #fff;
	}
  }

  .goodsArea {
    // margin-bottom: 40px;
    box-sizing: border-box;
    padding: 10px 5px 5px 5px;
    height: 100%;


    .children{
        display: inline-block;
        margin-right:8px;
    }

    .moreData{
        text-align: center;
        color:red;
        font-size: 12px;
        cursor: pointer;
        padding: 3px 0;
    }

    .hideData{
        text-align: center;
        color:#409EFF;;
        font-size: 12px;
        cursor: pointer;
       
        padding: 3px 0;
    }

  

    .variation{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        border-bottom: 1px solid #eee;
        padding-right: 20px;
        padding-bottom: 5px;;
        
    }

    .children:nth-child(1){
        width: 250px;
        word-break: normal;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .children2{
        width: 250px;
        word-break: normal;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .children3{
        width: 150px;
        word-break: normal;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .item_list{
        display: flex;
        
        border-bottom: 1px solid #eee;
        background-color: #fff;
        padding: 5px 0;

    }

    .item_list_wrpper{
        margin-bottom: 10px;
        border-bottom: 1px solid #eee;
        background-color: #fff;
        padding: 5px 0;
        border-radius: 3px;
        box-sizing: border-box;
        padding-left: 10px;
    }

    .itemDesc{
        width: 30%;
        overflow: hidden;
        margin:0 0 0 20px;
        border-right: 1px solid #eee;
    }

    .headerDesc{
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        padding:5px 30px 5px 0;


        .title{
          display: flex;
          align-items: center;
        }

        .kmvn{
          display: flex;
          justify-items: flex-start;
          margin-right: 30px;
          align-items: center;
        }

        .ciuk{
          cursor: pointer;
          color: #409EFF;
          margin:0 10px
        }


    }

    .imgBox{
        width: 60px;
        height: 60px;
        overflow: hidden;
    }

    
  }

  
}
</style>